import axios from "axios";

export default function updateGiftOrderSetting({ value }) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/campaign/api/admin/gift-setting/update`, {
        option: "order",
        value: value,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
